import { useMemo } from 'react';

import { useTypedParams } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { RequestLineupForm } from '#src/components/noCardRoute/RequestLineupForm/index.tsx';
import { disclaimerMessages } from '#src/lib/noCardRoute.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const NoCardEntry = () => {
  const { so5FixtureId } = useTypedParams<PageParams>();
  const { sport } = useSportContext();

  const disclaimers = useMemo(() => {
    const common = [disclaimerMessages.leaderboardSelection];
    if (sport === Sport.NBA) return common;

    const withEligibility = [disclaimerMessages.eligibilityCheck, ...common];
    if (sport === Sport.BASEBALL) return withEligibility;

    // Default (Football)
    return [...withEligibility, disclaimerMessages.captain];
  }, [sport]);

  return (
    <RequestLineupForm so5FixtureId={so5FixtureId} disclaimers={disclaimers} />
  );
};

export default NoCardEntry;
